import * as React from 'react'
import { Select } from 'antd-v4'
import { SelectProps } from 'antd-v4/lib/select'
import { IBaseCategory } from '@getgreenline/homi-shared'
import { PosListingModels } from '@getgreenline/inventory'
import { BlazeSelectFilter } from '../../../../../../components/CustomSelect/BlazeSelectFilter'
import { CategorySelectOption } from '../../../../../../containers/POS/Sale/ProductSidebar/SearchFilters/CategorySelectOption'

interface Props {
  flatCategories: IBaseCategory[]
  selectedCategoryIds?: (string | null)[]
  onChange?: SelectProps<string[]>['onChange']
  onSelect?: SelectProps<string[]>['onSelect']
  onDeselect?: SelectProps<string[]>['onSelect']
  onClear?: SelectProps<string[]>['onClear']
  onSelectAll?: (all: boolean) => void
  showAllandNone?: boolean
  style?: SelectProps<string[]>['style']
  className?: SelectProps<string[]>['className']
}

export const NestedCategoryFilter = (props: Props) => {
  const parsedCategoryIds = props.selectedCategoryIds?.map((categoryId) =>
    categoryId === null ? PosListingModels.FilterVocabulary.UNCATEGORIZED_NAME : categoryId,
  )

  return (
    <BlazeSelectFilter<string[]>
      placeholder='Select categories'
      mode='multiple'
      maxTagPlaceholder={`Categories (${
        parsedCategoryIds?.length === props.flatCategories.length
          ? 'all'
          : parsedCategoryIds?.length
      })`}
      onChange={props.onChange}
      onSelect={props.onSelect}
      onDeselect={props.onDeselect}
      onClear={props.onClear}
      value={parsedCategoryIds}
      style={props.style}
      className={props.className}
    >
      {props.showAllandNone && (
        <div className='text-right w-100 mb-2'>
          <a
            className='mr-2'
            onClick={() => {
              if (props.onSelectAll) {
                props?.onSelectAll(true)
              }
            }}
          >
            All
          </a>
          <a
            onClick={() => {
              if (props.onSelectAll) {
                props?.onSelectAll(false)
              }
            }}
          >
            None
          </a>
        </div>
      )}
      {props.flatCategories.map((category) => (
        <Select.Option
          key={category.id}
          value={category.id}
          label={category.name}
          style={{ alignItems: 'center' }}
        >
          <CategorySelectOption category={category} />
        </Select.Option>
      ))}
      {parsedCategoryIds?.includes(PosListingModels.FilterVocabulary.UNCATEGORIZED_NAME) && (
        <Select.Option
          key={`${PosListingModels.FilterVocabulary.UNCATEGORIZED_NAME}`}
          value={PosListingModels.FilterVocabulary.UNCATEGORIZED_NAME}
          label={PosListingModels.FilterVocabulary.UNCATEGORIZED_NAME}
          style={{ alignItems: 'center' }}
        >
          <CategorySelectOption />
        </Select.Option>
      )}
    </BlazeSelectFilter>
  )
}
